import { useEffect, useRef } from 'react'

interface Events {
    click?: (e: MouseEvent) => void
    resize?: (e: Event) => void
}

const useEvents = (target: HTMLElement | 'window', events: Events, preRequisite?: boolean) => {
    const eventNames = Object.keys(events)

    const ref = useRef(null)
    ref.current = events

    useEffect(() => {
        if (preRequisite === false) {
            return
        }

        if (target) {
            const actualTarget = target === 'window' ? window : target

            const cleanup = eventNames.map((eventName) => {
                const handler = (e: Event) => ref.current?.[eventName]?.(e)
                actualTarget.addEventListener(eventName, handler, false)
                return () => actualTarget.removeEventListener(eventName, handler)
            })

            return () => cleanup.forEach((clean) => clean())
        }
    }, [target, preRequisite, ...eventNames])
}

export default useEvents
